import React, { Component } from 'react';
import { connect } from 'react-redux';
import CardList from '../components/CardList';
import SearchBox from '../components/SearchBox';
import PinterestSearchBox from '../components/PinterestSearchBox';
import Scroll from '../components/Scroll';
import './App.css';
import Navigation from '../components/Navigation/Navigation';
import Register from '../components/Register/Register';
import Signin from '../components/Signin/Signin';
import { Route, Switch, Redirect, withRouter } from "react-router-dom";
import Profile from '../components/Profile';
import Rank from '../components/Rank';
import env from "react-dotenv";
import { setSearchField, requestRobots, clearSearchField } from '../actions';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Container from 'react-bootstrap/Container';
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';
import { FaSignOutAlt, FaUser, FaUsers, FaPlus } from "react-icons/fa";
import { Link } from "react-router-dom";

// Import encryption utilities
import { 
  setSecureItem, 
  getSecureItem, 
  removeSecureItem, 
  clearAllSecureData 
} from '../utils/encryption';

let URL = `${env.API_URL}/p10`;
let BLOCKED_URL = `${env.API_URL}/blocked`;
let BLOCKED_DIME_URL = `${env.API_URL}/blockedDimes`;

const mapStateToProps = state => {
  return {
    searchField: state.searchRobots.searchField,
    robots: state.requestRobots.robots,
    ispending: state.requestRobots.ispending,
    error: state.requestRobots.error
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    // Match Main.js - accept event object directly
    onSearchChange: (event) => dispatch(setSearchField(event.target.value)),
    onRequestRobots: () => dispatch(requestRobots()),
    clearSearchField: () => dispatch(clearSearchField()),
  };
};

// Global variables - exported for other components (kept exactly as-is)
export let uFirstName = '';
export let uLastName = '';
export let uRating = '';
export let uId = '';
export let uIsSignedIn = false;
export let uRatingCount = '';
export let uImageKey = '';
export let uAdministrator = '';
export let uGender = '';
export let uEmail = '';
export let uJoined = '';
export let uProfileImage = '';

// Global inactivity timer (persists across component remounts)
let globalInactivityTimer = null;
let globalActivityThrottle = false;
let globalForceLogout = null;

class App extends Component {
  constructor(props) {
    super(props);

    const savedState = this.loadStateFromStorage();

    this.state = {
      route: savedState.route || 'signin',
      isSignedIn: savedState.isSignedIn || false,
      updateFlag: false,
      isLoading: false,
      error: null,
      user: savedState.user || {
        id: '',
        first_name: '',
        last_name: '',
        gender: '',
        email: '',
        joined: '',
        profile_image: '',
        rating: '',
        rating_count: '',
        image_key: '',
        reported: '',
        administrator: ''
      },
      robots: [],
      blockedUsers: savedState.blockedUsers || [],
      blockedDimes: savedState.blockedDimes || [],
      filteredRobots: [], // NEW: Store unblocked robots here
      //searchfield: '',
      renderKey: 0 // NEW: Force re-render counter
    };

    if (savedState.user && savedState.user.id) {
      this.updateGlobalVariables(savedState.user);
    }

    this.resetUserState = this.resetUserState.bind(this);
    this.forceLogout = this.forceLogout.bind(this);
    this.onRouteChange = this.onRouteChange.bind(this);
    this.loadUser = this.loadUser.bind(this);
    this.resetInactivityTimer = this.resetInactivityTimer.bind(this);
    this.handleUserActivity = this.handleUserActivity.bind(this);

    this.inactivityTimer = null;
    this.activityEvents = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart', 'click'];
  }

  /**
   * Load encrypted state from localStorage
   */
  loadStateFromStorage() {
    try {
      // Use encrypted storage utility
      const savedState = getSecureItem('p10-app-state');
      
      if (savedState) {
        const MAX_STATE_AGE = 24 * 60 * 60 * 1000; // 24 hours
        
        // Check if state is still valid
        if (Date.now() - (savedState.timestamp || 0) < MAX_STATE_AGE) {
          return savedState;
        } else {
          removeSecureItem('p10-app-state');
        }
      }
    } catch (error) {
      console.error('Error loading encrypted state:', error);
      // Clear corrupted data
      removeSecureItem('p10-app-state');
    }
    return {};
  }

  /**
   * Save encrypted state to localStorage
   */
  saveStateToStorage() {
    try {
      const stateToSave = {
        isSignedIn: this.state.isSignedIn,
        user: {
          id: this.state.user.id,
          first_name: this.state.user.first_name,
          last_name: this.state.user.last_name,
          gender: this.state.user.gender,
          email: this.state.user.email,
          joined: this.state.user.joined,
          profile_image: this.state.user.profile_image,
          rating: this.state.user.rating,
          rating_count: this.state.user.rating_count,
          image_key: this.state.user.image_key,
          administrator: this.state.user.administrator
          // Note: Never store passwords or sensitive tokens
        },
        route: this.state.route,
        blockedUsers: this.state.blockedUsers,
        blockedDimes: this.state.blockedDimes,
        timestamp: Date.now()
      };
      
      // Use encrypted storage utility
      const success = setSecureItem('p10-app-state', stateToSave);
      
      if (success) {
        console.log('State encrypted and saved successfully');
      } else {
        console.error('Failed to save encrypted state');
      }
    } catch (error) {
      console.error('Error saving encrypted state:', error);
    }
  }

  updateGlobalVariables(user) {
    uFirstName = user.first_name || '';
    uLastName = user.last_name || '';
    uRating = user.rating || '';
    uId = user.id || '';
    uRatingCount = user.rating_count || '';
    uImageKey = user.image_key || '';
    uAdministrator = user.administrator || '';
    uGender = user.gender || '';
    uEmail = user.email || '';
    uJoined = user.joined || '';
    uProfileImage = user.profile_image || '';
    uIsSignedIn = true;
  }

  resetGlobalVariables() {
    uFirstName = '';
    uLastName = '';
    uRating = '';
    uId = '';
    uIsSignedIn = false;
    uRatingCount = '';
    uImageKey = '';
    uAdministrator = '';
    uGender = '';
    uEmail = '';
    uJoined = '';
    uProfileImage = '';
  }

  resetUserState() {
    this.stopInactivityTracking();
    
    this.setState({
      isSignedIn: false,
      route: 'signin',
      user: {
        id: '',
        first_name: '',
        last_name: '',
        gender: '',
        email: '',
        joined: '',
        profile_image: '',
        rating: '',
        rating_count: '',
        image_key: '',
        reported: '',
        administrator: ''
      },
      blockedUsers: [],
      blockedDimes: [],
      filteredRobots: []
    }, () => {
      // Clear all encrypted data
      try {
        clearAllSecureData();
      } catch (err) {
        console.error('Error clearing secure data on logout:', err);
      }
      this.resetGlobalVariables();
    });
  }

  forceLogout() {
    console.log('Force logout initiated - clearing all encrypted data');
    
    // Clear all encrypted data and encryption key
    try {
      clearAllSecureData();
    } catch (err) {
      console.error('Error clearing secure storage:', err);
    }
    
    this.resetGlobalVariables();
    
    this.setState({
      isSignedIn: false,
      route: 'signin',
      user: {
        id: '',
        first_name: '',
        last_name: '',
        gender: '',
        email: '',
        joined: '',
        profile_image: '',
        rating: '',
        rating_count: '',
        image_key: '',
        reported: '',
        administrator: ''
      },
      blockedUsers: [],
      blockedDimes: [],
      filteredRobots: []
    });

    this.stopInactivityTracking();

    setTimeout(() => {
      window.location.href = '/signin';
    }, 100);
  }

  handleUserActivity() {
    if (!globalActivityThrottle) {
      this.resetInactivityTimer();
      globalActivityThrottle = true;
      setTimeout(() => {
        globalActivityThrottle = false;
      }, 1000);
    }
  }

  startInactivityTracking() {
    this.resetInactivityTimer();
    
    if (!window.__inactivityListenersAttached) {
      this.activityEvents.forEach(evt => {
        document.addEventListener(evt, this.handleUserActivity, { 
          passive: true, 
          capture: true 
        });
      });
      window.__inactivityListenersAttached = true;
    }
  }

  stopInactivityTracking() {
    if (globalInactivityTimer) {
      clearTimeout(globalInactivityTimer);
      globalInactivityTimer = null;
    }
    
    globalActivityThrottle = false;
    
    this.activityEvents.forEach(evt => {
      document.removeEventListener(evt, this.handleUserActivity, true);
    });
    
    window.__inactivityListenersAttached = false;
  }

  resetInactivityTimer() {
    if (globalInactivityTimer) {
      clearTimeout(globalInactivityTimer);
    }

    const INACTIVITY_TIMEOUT = 15 * 60 * 1000;
    
    globalInactivityTimer = setTimeout(() => {
      try {
        alert('Your session has expired due to inactivity. Please sign in again.');
      } catch (err) {
        console.warn('Could not show alert:', err);
      }
      
      if (globalForceLogout) {
        globalForceLogout();
      } else {
        console.error('globalForceLogout not available!');
        try {
          clearAllSecureData();
          window.location.href = '/signin';
        } catch (err) {
          console.error('Fallback logout failed:', err);
        }
      }
    }, INACTIVITY_TIMEOUT);
  }

  async setStateApp() {
    try {
      const response = await fetch(URL, {
        method: 'GET',
        credentials: 'include',
        headers: { Authorization: env.API_KEY }
      });

      const users = await response.json();

      this.setState({ robots: users });

      return users;
    } catch (error) {
      console.error('Error fetching users:', error);
      return null;
    }
  }

  async getBlockedUsers() {
    this.setState({ isLoading: true });
    
    // First make sure we have robots data
    await this.setStateApp();
    
    // Use state robots (which we just fetched)
    const allRobots = this.state.robots || [];

    try {
      const response = await fetch(BLOCKED_URL, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify()
      });

      const users = await response.json();

      if (users === "Please sign in") {
        this.forceLogout();
        return;
      }

      const blockedUserIds = (users && users.map) ? users.map(user => user.profile_id) : [];

      // Filter blocked users
      const filteredUsers = allRobots.filter(
        robot => !blockedUserIds.includes(robot.id)
      );

      this.setState({
        blockedUsers: blockedUserIds,
        filteredRobots: filteredUsers,
        isLoading: false,
        error: null
      }, () => {
        this.saveStateToStorage();
      });
    } catch (error) {
      console.error('Error fetching blocked users:', error);
      this.setState({
        error: 'Failed to load profiles. Please try again.',
        isLoading: false
      });
    }
  }

  async getBlockedDimes() {
    // Make sure we have robots data
    await this.setStateApp();
    
    const allRobots = this.state.robots || [];

    try {
      const response = await fetch(BLOCKED_DIME_URL, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify()
      });

      const users = await response.json();

      if (users === "Please sign in") {
        this.forceLogout();
        return;
      }

      const blockedDimeIds = (users && users.map) ? users.map(user => user.dime_id) : [];

      // Apply both blocked users AND blocked dimes filters
      const filteredUsers = allRobots.filter(
        robot => !this.state.blockedUsers.includes(robot.id) && 
                 !blockedDimeIds.includes(robot.id)
      );

      this.setState({
        blockedDimes: blockedDimeIds,
        filteredRobots: filteredUsers
      }, () => {
        this.saveStateToStorage();
      });
    } catch (error) {
      console.error('Error fetching blocked dimes:', error);
    }
  }

  loadUser(data) {
    const userData = {
      id: data.id,
      first_name: data.first_name,
      last_name: data.last_name,
      email: data.email,
      gender: data.gender,
      joined: data.joined,
      rating: data.rating,
      rating_count: data.rating_count,
      image_key: data.image_key,
      profile_image: data.profile_image,
      reported: data.reported,
      administrator: data.administrator
    };

    this.setState({
      user: userData,
      isSignedIn: true
    }, () => {
      this.updateGlobalVariables(userData);
      this.saveStateToStorage();
      this.getBlockedUsers();
      this.startInactivityTracking();
    });
  }

  componentDidMount() {
    globalForceLogout = this.forceLogout;

    this.props.clearSearchField();
    
    if (this.state.isSignedIn && this.state.user.id) {
      this.getBlockedUsers();
      this.startInactivityTracking();
    }

    this.props.onRequestRobots();
    this.setStateApp();
  }

  componentWillUnmount() {
    if (!this.state.isSignedIn) {
      console.log('App unmounting - user logged out, stopping tracking');
      this.stopInactivityTracking();
    } else {
      console.log('App unmounting but user still signed in - keeping tracking active');
    }
  }

  componentDidUpdate(prevProps, prevState) {
      // Clear search when route changes (using React Router location)
    if (prevProps.location.pathname !== this.props.location.pathname) {
      if (prevProps.location.pathname === '/home' || this.props.location.pathname === '/home') {
        this.props.clearSearchField();
      }
    }
    // Save state when needed
    if (
      prevState.isSignedIn !== this.state.isSignedIn ||
      prevState.route !== this.state.route ||
      JSON.stringify(prevState.user) !== JSON.stringify(this.state.user)
    ) {
      this.saveStateToStorage();
    }

      // Clear search when leaving home page
    if (prevState.route === 'home' && this.state.route !== 'home' && this.props.searchField) {
      this.props.clearSearchField();
    }

    // Start tracking on signin
    if (!prevState.isSignedIn && this.state.isSignedIn && this.state.user.id) {
      console.log('User signed in during update - ensuring tracking is active');
      this.startInactivityTracking();
    }

    // Re-filter when blocked users change
    if (prevState.updateFlag !== this.state.updateFlag && this.state.updateFlag === true) {
      this.getBlockedUsers();
      this.setState({ updateFlag: false });
    }

    // Re-filter when state robots update
    if (prevState.robots !== this.state.robots && this.state.robots.length > 0 && this.state.isSignedIn) {
      const allRobots = this.state.robots || [];
      const filteredUsers = allRobots.filter(
        robot => !this.state.blockedUsers.includes(robot.id) &&
                 !this.state.blockedDimes.includes(robot.id)
      );
      if (filteredUsers.length > 0) {
        this.setState({ filteredRobots: filteredUsers });
      }
    }

    // Just log when search changes, don't call setState
    if (prevProps.searchField !== this.props.searchField) {
      console.log('Search field changed:', this.props.searchField);
    }
  }

  onRouteChange(route) {
  if (route === 'signout') {
    this.forceLogout();
    return;
  }

  if (route === 'home') {
    // Clear search when entering home page fresh
    this.props.clearSearchField();
    this.setState({ isSignedIn: true, route: 'home', updateFlag: true });
    return;
  }

  // Clear search when navigating away from home
  if (this.state.route === 'home' && route !== 'home') {
    this.props.clearSearchField();
  }

  this.setState({ route: route });
}

  ProtectedRoute = ({ component: Component, render, ...rest }) => {
  const { isSignedIn, user } = this.state;

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!isSignedIn || !user?.id) {
          return <Redirect to="/signin" />;
        }

        // Prefer render prop if provided
        if (render) {
          return render(props);
        }

        // Otherwise render component normally
        if (Component) {
          return (
            <Component
              {...props}
              user={user}
              robots={this.state.robots}
              loadUser={this.loadUser}
              onRouteChange={this.onRouteChange}
              setTest={this.setStateApp.bind(this)}
            />
          );
        }

        return null;
      }}
    />
  );
};

  render() {
    const { isSignedIn, isLoading, error, user } = this.state;
    const { searchField, ispending } = this.props;

    // Use filteredRobots if available, otherwise use state.robots
    const robotsToSearch = this.state.filteredRobots.length > 0 
      ? this.state.filteredRobots 
      : this.state.robots || [];

    // Ensure searchField is defined and trim it
    const searchTerm = (searchField || '').toLowerCase().trim();

    const filteredRobots = robotsToSearch.filter(robot => {
      try {
        // If no search term, show all
        if (!searchTerm) return true;
        
        // Make sure robot has required properties
        if (!robot || !robot.first_name) return false;
        
        // Search in both first and last name
        const firstName = (robot.first_name || '').toLowerCase();
        const lastName = (robot.last_name || '').toLowerCase();
        const fullName = `${firstName} ${lastName}`;
        
        return firstName.includes(searchTerm) || 
               lastName.includes(searchTerm) || 
               fullName.includes(searchTerm);
      } catch (err) {
        console.error('Filter error:', err);
        return false;
      }
    });


    if (ispending) {
      return <h1>Loading</h1>;
    }

    return (
      <div className='tc'>

        <Switch>
          {/* Public Routes */}
          <Route
            path="/signin"
            render={(props) =>
              isSignedIn ? (
                <Redirect to="/home" />
              ) : (
                <Signin
                  {...props}
                  loadUser={this.loadUser}
                  onRouteChange={this.onRouteChange}
                />
              )
            }
          />

          <Route
            path="/register"
            render={(props) =>
              isSignedIn ? (
                <Redirect to="/home" />
              ) : (
                <Register
                  {...props}
                  setTest={this.setStateApp.bind(this)}
                  loadUser={this.loadUser}
                  onRouteChange={this.onRouteChange}
                />
              )
            }
          />

          {/* Protected Home Route - Modernized */}
          <this.ProtectedRoute
            path="/home"
            render={() => (
              <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
                {/* Modern Top Navigation */}
                <Navbar expand="lg" fixed="top" bg="white" variant="light" style={{ boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
                  <Container fluid style={{ maxWidth: '1800px' }}>
                    <Navbar.Brand href="/home" style={{ display: 'flex', alignItems: 'center', marginRight: '20px' }}>
                      <img src="/images/p10.jpg" alt="P10" style={{ height: '32px', width: '32px', marginRight: '8px',borderRadius: '8px' }}/>
                      <span style={{ fontWeight: '600', fontSize: '1.2rem', color: '#1f2937' }}>P10 Rating</span>
                    </Navbar.Brand>
                    
                    <div style={{ 
                      flex: '1', 
                      maxWidth: '900px', 
                      margin: '0 20px',
                      display: window.innerWidth < 992 ? 'none' : 'block'
                    }}>
                      <PinterestSearchBox 
                        searchChange={this.props.onSearchChange}
                        searchField={searchField}
                        placeholder="Search profiles by name..."
                      />
                    </div>
                    
                    <Navbar.Toggle aria-controls="main-navbar" />
                    <Navbar.Collapse id="main-navbar">
                      <div style={{ 
                        display: window.innerWidth >= 992 ? 'none' : 'block',
                        padding: '10px 0'
                      }}>
                        <PinterestSearchBox 
                          searchChange={this.props.onSearchChange}
                          searchField={searchField}
                          placeholder="Search profiles by name..."
                        />
                      </div>
                      
                      <Nav className="ms-auto">
                        <Link to={'/profile'} className="nav-link" style={{ fontWeight: '600' }} onClick={() => this.props.clearSearchField()}>
                          <FaUser style={{ marginRight: '6px' }}/> Profile
                        </Link>
                        <Link to={'/dimes'} className="nav-link" style={{ fontWeight: '600' }}    onClick={() => this.props.clearSearchField()}>
                          <FaUsers style={{ marginRight: '6px' }}/> Dimes
                        </Link>
                        <Link to={'/addDime'} className="nav-link" style={{ fontWeight: '600' }} onClick={() => this.props.clearSearchField()}>
                          <FaPlus style={{ marginRight: '6px' }}/> Add Dimes
                        </Link>
                        <Link to={'/signin'} className="nav-link" style={{ fontWeight: '600', color: '#e60023' }} onClick={() => this.onRouteChange('signout')}>
                          <FaSignOutAlt style={{ marginRight: '6px' }}/> Log out
                        </Link>
                      </Nav>
                    </Navbar.Collapse>
                  </Container>
                </Navbar>

                {/* Main Content */}
                <Container fluid style={{ paddingTop: '100px', paddingBottom: '100px', maxWidth: '1400px' }} key={`search-${searchField || 'all'}`}>
                  <div className="tc">
                    {/* Welcome Message */}
                    {user.first_name && (
                      <h1 style={{ fontSize: '2.5rem', fontWeight: '700', color: '#1f2937', marginBottom: '10px' }}>
                        Welcome, {user.first_name}!
                      </h1>
                    )}
                    <h2 style={{ fontSize: '1.5rem', color: '#6b7280', marginBottom: '40px' }}>
                      Discover and Rate Profiles
                    </h2>
                    
                    {/* Error Alert */}
                    {error && (
                      <Alert variant="danger" dismissible onClose={() => this.setState({ error: null })}>
                        {error}
                      </Alert>
                    )}
                    
                    {/* Loading Spinner */}
                    {isLoading ? (
                      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
                        <Spinner animation="border" role="status" variant="primary">
                          <span className="sr-only">Loading...</span>
                        </Spinner>
                      </div>
                    ) : (
                      <>
                        {/* No Results Message */}
                        {filteredRobots.length === 0 && !isLoading && (
                          <div style={{ textAlign: 'center', padding: '80px 20px' }}>
                            <h2 style={{ color: '#6b7280', marginBottom: '10px' }}>No profiles found</h2>
                            <p style={{ color: '#9ca3af' }}>Try adjusting your search or refresh the page</p>
                          </div>
                        )}
                        
                        {/* Grid Layout */}
                        {filteredRobots.length > 0 && (
                          <React.Fragment key={`grid-${searchField || 'all'}-${filteredRobots.length}`}>
                            <div style={{
                              display: 'grid',
                              gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                              gap: '24px',
                              padding: '20px'
                            }}>
                              {filteredRobots.map((robot, index) => (
                                <div key={`card-${robot.id}-${index}`}>
                                  <CardList 
                                    setTest={this.setStateApp.bind(this)} 
                                    robots={[robot]} 
                                  />
                                </div>
                              ))}
                            </div>
                          </React.Fragment>
                        )}
                      </>
                    )}
                  </div>
                </Container>

                {/* Modern Footer */}
                <div style={{ 
                  backgroundColor: 'white',
                  borderTop: '1px solid #e5e7eb',
                  padding: '20px 0',
                  position: 'fixed',
                  bottom: 0,
                  width: '100%',
                  boxShadow: '0 -2px 4px rgba(0,0,0,0.05)'
                }}>
                  <Container>
                    <div style={{ 
                      display: 'flex', 
                      justifyContent: 'center', 
                      alignItems: 'center',
                      flexWrap: 'wrap',
                      gap: '20px',
                      fontSize: '0.9rem'
                    }}>
                      <span style={{ color: '#6b7280' }}>© 2025 p10rating</span>
                      <Link to="/privacypolicy" style={{ color: '#3b82f6', textDecoration: 'none' }}>Privacy</Link>
                      <Link to="/disclaimer" style={{ color: '#3b82f6', textDecoration: 'none' }}>Disclaimer</Link>
                      <Link to="/terms" style={{ color: '#3b82f6', textDecoration: 'none' }}>Terms</Link>
                      <Link to="/about" style={{ color: '#3b82f6', textDecoration: 'none' }}>About</Link>
                    </div>
                  </Container>
                </div>
              </div>
            )}
          />

          <this.ProtectedRoute path="/profile" component={Profile} />
          <this.ProtectedRoute path="/rank" component={Rank} />

          {/* Default Route */}
          <Route
            exact
            path="/"
            render={() => (isSignedIn ? <Redirect to="/home" /> : <Redirect to="/signin" />)}
          />

          {/* 404 Route */}
          <Route
            render={() => (
              <div className="tc pa4">
                <h1>404 - Page Not Found</h1>
                <button
                  onClick={() => this.onRouteChange(isSignedIn ? 'home' : 'signin')}
                  className="f6 link dim br3 ph3 pv2 mb2 dib white bg-dark-green pointer"
                >
                  Go {isSignedIn ? 'Home' : 'to Sign In'}
                </button>
              </div>
            )}
          />
        </Switch>
      </div>
    );
  }
}

export default withRouter(connect(
  mapStateToProps, 
  mapDispatchToProps,
  null,
  { forceUpdate: true }
)(App));